import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import Select from "react-select";
import Async from "react-select/async";

const InlineEdit = ({
  children,
  type,
  value,
  name,
  onSubmit,
  updateFeatureHandler,
  ...rest
}) => {
  
  const [isEdit, setIsEdit] = useState(false);
  const refinput = useRef(null);
  const [formdata, setFormdata] = useState({});
  const [error, setError] = useState({});

  const inlineEditHandler = () => {
    setIsEdit(true);
  };

  const cancelEditHandler = () => {
    setIsEdit(false);
  };

  const saveEditHandler = () => {
    for (let ke in error) {
      if (error.hasOwnProperty(ke) && error[ke]) {
        return;
      }
    }
    onSubmit(formdata);
    setIsEdit(false);
  };

  const inputHandlerChange = (evt) => {
    const { name, value } = evt.target;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (value && name === "email") {
      if (!emailPattern.test(value)) {
        setError((state) => {
          return {
            ...state,
            [name]: "Invalid Email",
          };
        });
      } else {
        setError((state) => {
          return {
            ...state,
            [name]: "",
          };
        });
      }
    } else {
      setError((state) => {
        return {
          ...state,
          [name]: "",
        };
      });
    }
    setFormdata((state) => {
      return {
        ...state,
        [name]: value,
      };
    });
  };

  const selectChangeHandler = (field, evt) => {
    
    setFormdata((state) => {
      return {
        ...state,
        [name]: evt,
      };
    });
  };

  // const marketFeedbackChangeHandler = (evt, act) => {
  //   console.log(evt, act, formdata, 356456757);
  //   const { action, option, removedValue } = act;
  //   if (action === "remove-value") {
  //     setFormdata((state) => {
  //       return {
  //         ...state,
  //         customer_tattle_uuid: removedValue.value,
  //         isAdding: false,
  //         [name]: evt,
  //       };
  //     });
  //   }

  //   if (action === "select-option") {
  //     setFormdata((state) => {
  //       return {
  //         ...state,
  //         customer_tattle_uuid: option.value,
  //         isAdding: true,
  //         [name]: evt,
  //       };
  //     });
  //   }
  // };

  const asyncChangeHandler = (field, evt, acc) => {
    
    setFormdata({
      ...formdata,
      [field]: evt.map((ite) => ite.value),
    });
  };

  useEffect(() => {
    refinput.current && refinput.current.focus();
  }, [refinput, isEdit]);

  useEffect(() => {
    
    setFormdata((state) => {
      return {
        ...state,
        [name]: value,
      };
    });
  }, [value, name, isEdit]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      wordBreak: "break-all",
    }),
    control: (styles, state) => {
      return {
        ...styles,
        fontSize: "12px",
        textAlign: "left",
        boxShadow: "none",
        height: 50,
        overflowY: "auto",
      };
    },
    menu: () => {
      return {
        boxShadow: "none",
        marginTop: "10px",
      };
    },
    menuList: (style) => {
      return {
        ...style,
        maxHeight: 180,
      };
    },
  };

  if (type === "text" || type === "email") {
    if (isEdit) {
      return (
        <React.Fragment>
          <div>
            <div className="inline_edit">
              <input
                type={type}
                value={formdata[name]}
                className="form-control"
                ref={refinput}
                onChange={inputHandlerChange}
                name={name}
              />
              <div className="edit_icon_edit">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#0cb9f2"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#fff"
                  className="w-6 h-6"
                  width="26px"
                  height="26px"
                  onClick={saveEditHandler}
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="rgba(48, 48, 73, 0.7)"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#fff"
                  className="w-6 h-6"
                  width="26px"
                  height="26px"
                  onClick={cancelEditHandler}
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
              </div>
            </div>
          </div>
          {error.hasOwnProperty("email") && error.email && (
            <div className="error-feedback">{error.email}</div>
          )}
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div>
          <div
            className={`inline_edit ${
              formdata[name] === "" ? "enable_height" : ""
            }`}
          >
            {" "}
            {children}
            <span onClick={inlineEditHandler}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="rgba(48, 48, 73, 0.7)"
                className="editsvg"
              >
                <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
              </svg>
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  }
  
  if (type === "select") {
    

    if (isEdit) {
      return (
        <React.Fragment>
          <div>
            <div className="inline_edit">
              <Select
                isMulti
                className="multi-select"
                classNamePrefix="multi-select"
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                styles={customStyles}
                {...rest}
                // menuIsOpen={true}
                onChange={(evt) => selectChangeHandler("product", evt)}
                ref={refinput}
                value={formdata[name]}
              />
              <div className="edit_icon_edit">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#0cb9f2"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#fff"
                  className="w-6 h-6"
                  width="26px"
                  height="26px"
                  onClick={saveEditHandler}
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="rgba(48, 48, 73, 0.7)"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#fff"
                  className="w-6 h-6"
                  width="26px"
                  height="26px"
                  onClick={cancelEditHandler}
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div>
          <div
            className={`inline_edit ${
              formdata[name] && formdata[name].length === 0
                ? "enable_height"
                : ""
            }`}
          >
            {children}
            <span onClick={inlineEditHandler}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="rgba(48, 48, 73, 0.7)"
                className="editsvg"
              >
                <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
              </svg>
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  }

  if (type === "async") {
    if (isEdit) {
      return (
        <React.Fragment>
          <div>
            <div className="inline_edit">
              <Async
                isMulti
                styles={customStyles}
                className="multi-select"
                classNamePrefix="multi-select"
                closeMenuOnSelect={false}
                menuIsOpen={true}
                hideSelectedOptions={false}
                {...rest}
                // menuIsOpen={true}
                onChange={(evt, ac) => asyncChangeHandler(name, evt, ac)}
                ref={refinput}
                value={
                  formdata[name] &&
                  formdata[name].map((it) => ({ label: it, value: it }))
                }
              />
              <div className="edit_icon_edit">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#0cb9f2"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#fff"
                  className="w-6 h-6"
                  width="26px"
                  height="26px"
                  onClick={saveEditHandler}
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="rgba(48, 48, 73, 0.7)"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#fff"
                  className="w-6 h-6"
                  width="26px"
                  height="26px"
                  onClick={cancelEditHandler}
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div>
          <div
            className={`inline_edit ${
              formdata[name] && formdata[name].length === 0
                ? "enable_height"
                 : formdata[name] === undefined && "enable_height"
            }`}
          >
            {children}
            <span onClick={inlineEditHandler}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="rgba(48, 48, 73, 0.7)"
                className="editsvg"
              >
                <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
              </svg>
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

export default InlineEdit;



// WEBPACK FOOTER //
// ./src/components/chat/InlineEdit.js